module.exports = __webpack_public_path__ + "img/button_next_top_inactive.9864752d.svg";